<template>
  <div class="post">
    <!-- header -->
    <div class="post_header">
      <!-- title -->
      <div class="card card-body pb-0" style="border-radius: 10px">
        <table class="table" width="100%">
          <tr>
            <td><strong>Title</strong></td>
            <td>{{ event.title || "title" }}</td>
          </tr>

          <tr>
            <td><strong>Published</strong></td>
            <td>{{ event.published === 1 ? "Yes" : "No" }}</td>
          </tr>
          <tr>
            <td><strong>Featured</strong></td>
            <td>
              <span>{{ event.featured === 1 ? "Yes" : "No" }}</span>
            </td>
          </tr>
          <tr>
            <td><strong>Slug</strong></td>
            <td>
              <span>{{ event.slug || "" }}</span>
            </td>
          </tr>

        </table>
      </div>
      <span class="clearfix d-block mb-3"></span>
    </div>
  </div>
</template>

<script>
import helpers from "@/helpers";

export default {
 

  data: function (){
    return {
      product: localStorage.getItem('product')
    };
  },

  computed: {
    event: function () {
      return this.$store.getters["events/event"];
    },

    caption: function () {
      if (!!this.post.caption && this.post.caption != "undefined") {
        return this.$baseURL + "/storage/posts/captions/" + this.post.caption;
      } else return this.$baseURL + "/images/default.jpg";
    },

    body: function () {
      if (!this.post.body) {
        return this.post.body.replace(
            /"posts\/images\/.*?\.png/g,
            (imagePath) => {
              return '"' + this.$baseURL + "/storage/" + imagePath.substr(1);
            }
        );
      }
      return "";
    },

  },


  created() {
    this.page = helpers.getPageQuery();
    this.$store.dispatch('events/view', this.$route.params.slug)
  },
  methods: {

  },
};
</script>
